import React from "react";

import "./Chat.scss";

export default ({ children, className, ...props }) => {
  let classes = `header-chat ${className}`;
  return <div className={classes}>{children}</div>;
};
